export const SPRING_CONFIG = {
  stiffness: 500,
  damping: 15,
  mass: 0.1,
}